import { DdpCta } from "@/components/shared/DdpCta";
import { DdpImage } from "@/components/shared/DdpImage";
import { TDdpCta, TDdpMedia } from "@/shared/types";

export function NinthSection(props: Array<{
    title: string
    description: string
    backgroundImage: Array<TDdpMedia>
    cTA:Array<TDdpCta>
}>) {
    const { title, description, backgroundImage, cTA } = props[0]
    return (
        <div className="landing-ninth-section">
            <DdpImage className="bg" image={backgroundImage[0]} />
            <div className="content-wrapper">
                <div className="title">{title}</div>
                <div className="description" dangerouslySetInnerHTML={{ __html: description }} />
                <DdpCta className="cta-go-quiz white" cta={cTA[0]} />
            </div>
        </div>
    );
}